/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trackNumber: NonNullable<unknown> }} Track_Label_Aria_LabelInputs */

const en_track_label_aria_label = /** @type {(inputs: Track_Label_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Track ${i?.trackNumber}`)
};

const fr_track_label_aria_label = /** @type {(inputs: Track_Label_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Piste ${i?.trackNumber}`)
};

const de_track_label_aria_label = /** @type {(inputs: Track_Label_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Track ${i?.trackNumber}`)
};

const it_track_label_aria_label = /** @type {(inputs: Track_Label_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Traccia ${i?.trackNumber}`)
};

const ru_track_label_aria_label = /** @type {(inputs: Track_Label_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Трек ${i?.trackNumber}`)
};

const es_track_label_aria_label = /** @type {(inputs: Track_Label_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pista ${i?.trackNumber}`)
};

const zh_cn2_track_label_aria_label = /** @type {(inputs: Track_Label_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`追踪${i?.trackNumber}`)
};

const ja_track_label_aria_label = /** @type {(inputs: Track_Label_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`トラック ${i?.trackNumber}`)
};

const hi_track_label_aria_label = /** @type {(inputs: Track_Label_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ट्रैक ${i?.trackNumber}`)
};

const pt_pt2_track_label_aria_label = /** @type {(inputs: Track_Label_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Faixa ${i?.trackNumber}`)
};

/**
* | output |
* | --- |
* | "Track {trackNumber}" |
*
* @param {Track_Label_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const track_label_aria_label = /** @type {((inputs: Track_Label_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Track_Label_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_track_label_aria_label(inputs)
	if (locale === "de") return de_track_label_aria_label(inputs)
	if (locale === "it") return it_track_label_aria_label(inputs)
	if (locale === "ru") return ru_track_label_aria_label(inputs)
	if (locale === "es") return es_track_label_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_track_label_aria_label(inputs)
	if (locale === "ja") return ja_track_label_aria_label(inputs)
	if (locale === "hi") return hi_track_label_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_track_label_aria_label(inputs)
	return en_track_label_aria_label(inputs)
});